import { CssBaseline, ThemeProvider } from "@material-ui/core";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { store, StoreContext } from "store/StoreConfigs";
import App from "./App";
import "mapbox-gl/dist/mapbox-gl.css";
import "react-toastify/dist/ReactToastify.css";
import "./styling/index.css";
import { theme } from "./styling/theme";
import { Chart, registerables } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";

Chart.register(...registerables);
Chart.register(annotationPlugin);

ReactDOM.render(
    <React.StrictMode>
        <StoreContext.Provider value={store}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </ThemeProvider>
        </StoreContext.Provider>
    </React.StrictMode>,
    document.getElementById("root")
);
